import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { PeriodProvider } from 'components/PeriodContext';
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import StrategyDropdown from "components/StrategyDropdown";
import DataWidgets from "components/DataWidgets"; // Create this component to display data widgets

const BacktestingDashboard = ({ userID, initialCapital, userData }) => {
  const [selectedStrategies, setSelectedStrategies] = useState([]);
  const [metrics, setMetrics] = useState({});
  

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log("User is signed in with UID:", user.uid);
      } else {
        console.log("User is signed out");
      }
    });
  }, []);

  const handleStrategySelect = (strategyIds) => {
    setSelectedStrategies(strategyIds);
  };
  const handleMetricsUpdate = (newMetrics) => {
    setMetrics(newMetrics);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <PeriodProvider>
          <MDBox mb={3}>
            <StrategyDropdown userID={userID} onSelect={handleStrategySelect} onMetricsUpdate={handleMetricsUpdate} />
          </MDBox>
          {selectedStrategies.length > 0 ? (
            <MDBox>
              <DataWidgets userID={userID} strategyIds={selectedStrategies} metrics={metrics} compareMode={false} />
            </MDBox>
          ) : (
            <MDBox>
              <p></p>
            </MDBox>
          )}
        </PeriodProvider>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

BacktestingDashboard.propTypes = {
  userID: PropTypes.string.isRequired,
  initialCapital: PropTypes.number.isRequired,
  userData: PropTypes.object,
};

export default BacktestingDashboard;